export const HowItWorksSection = () => {
  const steps = [
    { number: "1", title: "Register", description: "Create your account and select your path" },
    { number: "2", title: "Explore", description: "Browse trades, courses, or competitions" },
    { number: "3", title: "Grow", description: "Learn, connect, and build your future" },
  ];
  
  return (
    <section className="py-24 bg-cream/50" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold tracking-widest text-teal-700 uppercase">Simple Process</span>
          <h2 className="text-4xl font-bold text-slate-800 mt-4">How It Works</h2>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center" data-testid={`step-${index}`}>
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg border-4 border-terracotta/20">
                <span className="text-3xl font-bold text-terracotta">{step.number}</span>
              </div>
              <h3 className="text-xl font-semibold text-slate-800 mb-3">{step.title}</h3>
              <p className="text-slate-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
